import React from 'react';
import { Box } from '@mui/material';
import { useChatContext } from '../context/ChatContext';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import RightSidebar from './RightSidebar';
import LoadingOverlay from './LoadingOverlay';
import ErrorDialog from './ErrorDialog';

  // console.log('MainLayout rendered');

const MainLayout: React.FC = () => {
  const { uiState, appState } = useChatContext();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        width: '100%',
        height: '100vh'
      }}
    >
      <Sidebar />
      <MainContent />
      <RightSidebar />
      {uiState.showLoading && (
        <LoadingOverlay 
          message={uiState.loadingMessage} 
        />
      )}
      {uiState.showError && <ErrorDialog message={uiState.errorMessage} />}
    </Box>
  );
};

export default MainLayout; 